import { SystemMessageStatus } from 'src/app/models/system-messages/system-message-types';

export class SystemMessageModel {
    public message: string;
    public status: SystemMessageStatus;
    public timing: number;

    constructor(data?: Partial<SystemMessageModel>) {
        this.message = '';
        this.timing = 5;

        if (data) {
            this.cast(data);
        }
    }
    private cast(data: Partial<SystemMessageModel>) {
        this.message = data.message || '';
        this.status = data.status || SystemMessageStatus.Info;
        if (data.timing) this.timing = data.timing;
    }
}
